import { render } from "./CIS-Latest-Insights.vue?vue&type=template&id=512213ab&scoped=true"
import script from "./CIS-Latest-Insights.vue?vue&type=script&lang=js"
export * from "./CIS-Latest-Insights.vue?vue&type=script&lang=js"

import "./CIS-Latest-Insights.vue?vue&type=style&index=0&id=512213ab&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512213ab"]])

export default __exports__